const GetUserID = () => {
  const id = window.localStorage.getItem('user_id');

  return id;
};

export default GetUserID;
